import {
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import { Auth } from "aws-amplify";
import { useEffect, useRef } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {
  ChatContainer,
  MainContainer,
  Message,
  MessageInput,
  MessageList,
  TypingIndicator,
} from "@chatscope/chat-ui-kit-react";
import { useState } from "react";
import Swal from "sweetalert2";
import { deleteUserFolder } from "../../utils/deleteUserFolder";
import { uploadFileViaPresignedUrl } from "../../utils/uploadFileViaPresignedUrl";
export default function PolicyChatbot({ chatbotTitle, link }) {
  const [csvFile, setCsvFile] = useState(null);
  const [csvload, setcsvload] = useState(false);
  const [trainload, setTrainload] = useState(false);
  const [answerload, setAnswerload] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(false);
  // const [question, setQuestion] = useState("");
  const [output, setOutput] = useState("");
  const [error, setError] = useState("");
  const [deleteError, setdeleteError] = useState("");
  const [selectedModel, setSelectedModel] = useState(
    "anthropic.claude-haiku-4-5-20251001-v1:0",
  );
  const [modeltext, setModelText] = useState("Claude Haiku");
  const timetaken = useRef(0);
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setCsvFile(file);
  };
  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  const [messages, setMessages] = useState([]);
  const [genaiaccess, setgenaiaccess] = useState(false);

  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);

  const handleSendMessage = (messageText) => {
    // Create a new message object
    const newMessage = {
      id: Math.random().toString(), // Generate a unique ID for the message
      text: messageText,
      sender: "User",
      direction: "outgoing",
    };
    // Update the messages state by adding the new message
    setMessages((prevMessages) => [...prevMessages, newMessage]);
    handleQuestion(messageText);
  };

  const exportMessages = () => {
    const dataString = messages
      .map((entry) => {
        return `${entry.sender}: ${entry.text}`;
      })
      .join("\n");
    console.log(dataString);
    // const encodedData = encodeURIComponent(dataString);
    // console.log(encodedData)
    const blob = new Blob([dataString], { type: "text/plain" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "chat_data.txt";
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  const handleQuestion = async (question) => {
    if (question.length > 0) {
      timetaken.current = 0;
      let time = setInterval(() => {
        timetaken.current = parseFloat(timetaken.current) + 0.1;
      }, 100);
      setAnswerload(true);
      console.log("reqeusting");
      var username = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );
      var data = JSON.stringify({
        model: selectedModel,
        question: question,
        docpath: username,
      });

      var xhr = new XMLHttpRequest();
      xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
          setOutput(JSON.parse(this.responseText));
          console.log(JSON.parse(this.responseText));
          setAnswerload(false);
          // selectedModel == "ai21.j2-ultra-v1"
          // ? "Jurassic-2 Ultra\n"
          // : selectedModel == "meta.llama2-13b-chat-v1"
          // ? "LLama 13B\n"
          // : selectedModel == "anthropic.claude-haiku-4-5-20251001-v1:0" &&
          //   "Claude Haiku\n"
          const newMessage = {
            id: Math.random().toString(), // Generate a unique ID for the message errorMessage
            text: JSON.parse(this.responseText)["messsage"]
              ? "Response by " +
                modeltext +
                "\n\n" +
                JSON.parse(this.responseText)["messsage"] +
                "\n\nTime taken: " +
                timetaken.current.toFixed(2) +
                " sec"
              : JSON.parse(this.responseText)["errorMessage"] &&
                "Response by " +
                  modeltext +
                  "\n" +
                  "Something went wrong" +
                  "\n\nTime taken: " +
                  timetaken.current.toFixed(2) +
                  " sec",
            sender: "Chatbot",
            direction: "incoming",
          };
          clearInterval(time);
          // Update the messages state by adding the new message
          setMessages((prevMessages) => [...prevMessages, newMessage]);
        }
      });

      xhr.open(
        "POST",
        // "https://ixies944jb.execute-api.ap-south-1.amazonaws.com/dev/getanswer"
        "https://6twdcbjz17.execute-api.ap-south-1.amazonaws.com/dev/custom-chatbot-response",
      );
      xhr.setRequestHeader("Content-Type", "application/json");

      xhr.send(data);
    } else {
      setError("please enter question");
    }
  };

  const handleTrain = async () => {
    //add filename passing parameter in post request and run post request of chatbot
    if (csvFile) {
      setTrainload(true);
      setdeleteError("");

      // new Promise((resolveOuter) => {
      //   resolveOuter(
      //     new Promise((resolveInner) => {
      //       setTimeout(resolveInner, 5000);
      //     }),
      //   );
      // }).then(()=>{setTrainload(false)})
      console.log("training started");
      var username = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );
      var data = JSON.stringify({
        docpath: username,
        docname: csvFile.name,
      });

      var xhr = new XMLHttpRequest();
      // xhr.withCredentials = true;
      xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
          if (this.responseText.toString().includes("errorMessage")) {
            Swal.fire("Please upload data file.");
            setTrainload(false);
          } else {
            console.log(this.responseText);
            setError("Training completed!");
            setTrainload(false);
          }
        }
      });

      xhr.open(
        "POST",
        // "https://ixies944jb.execute-api.ap-south-1.amazonaws.com/dev/documentloader"
        "https://6twdcbjz17.execute-api.ap-south-1.amazonaws.com/dev/custom-chatbot",
      );
      // xhr.setRequestHeader("Content-Type", "application/json");

      xhr.send(data);
    } else {
      Swal.fire("Please upload data file.");
    }
  };
  const getUsername = () =>
    localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );

  const handleUpload = async () => {
    setcsvload(true);

    try {
      const username = getUsername();
      await deleteUserFolder(username);
      await uploadFileViaPresignedUrl(csvFile, username);

      setcsvload(false);
      setError("File uploaded successfully.");
      setUploadStatus(true);
      // setCsvFile(null);
    } catch (error) {
      console.error("Error uploading file:", error);
      setError(
        "Error while uploading file, please refresh the page and try again.",
      );
      setcsvload(false);
    }
  };
  return (
    <div>
      <div>
        <img
          alt="overlay-img"
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          alt="main-background-img"
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to={link}>
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              {chatbotTitle}
            </h2>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                                <Button  variant="contained" color="primary" >Home</Button>
                            </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>

      {genaiaccess ? (
        <div className="emailsum-container" style={{ alignContent: "start" }}>
          <div className="input-form-chatbot" style={{ margin: "0 2rem" }}>
            <h3>
              <strong>Training Window</strong>
            </h3>
            <hr style={{ background: "white" }}></hr>
            <div className="field">
              <p>Select PDF file to train:</p>
              <div>
                <input
                  accept=".pdf"
                  id="csv-upload"
                  type="file"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />

                <label htmlFor="csv-upload">
                  <Button variant="contained" component="span">
                    Select PDF
                  </Button>
                </label>
                <Typography variant="body1">
                  {csvFile && `Selected file: ${csvFile.name}`}
                </Typography>

                <br />
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={!csvFile}
                    onClick={handleUpload}
                    style={{ margin: "0 1rem 0 0" }}
                    startIcon={
                      csvload && <CircularProgress color="white" size={20} />
                    }
                  >
                    Upload
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    style={{ color: "white" }}
                    onClick={handleTrain}
                    startIcon={
                      trainload && <CircularProgress color="white" size={20} />
                    }
                  >
                    Train
                  </Button>
                  {uploadStatus && (
                    <FaCheckCircle
                      style={{
                        marginLeft: "1rem",
                        color: "green",
                        top: "1rem",
                      }}
                      size={25}
                    />
                  )}
                </div>
              </div>
              <br />
              {error}
            </div>
            <FormControl>
              <p>Select a model:</p>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
                value={selectedModel}
                onChange={(e) => {
                  if (e.target.value === "meta.llama3-70b-instruct-v1:0") {
                    setModelText("LLAMA 3");
                  } else if (
                    e.target.value === "anthropic.claude-haiku-4-5-20251001-v1:0"
                  ) {
                    setModelText("Claude Haiku");
                  }

                  setSelectedModel(e.target.value);
                }}
              >
                <FormControlLabel
                  value="anthropic.claude-haiku-4-5-20251001-v1:0"
                  control={<Radio />}
                  label="Claude Haiku"
                />
                <FormControlLabel
                  value="meta.llama3-70b-instruct-v1:0"
                  control={<Radio />}
                  label="LLAMA 3"
                />
              </RadioGroup>
            </FormControl>

            <br />
            <br />
            <Button
              variant="contained"
              color="primary"
              component="span"
              style={{ color: "white" }}
              onClick={async () => {
                try {
                  const username = getUsername();
                  await deleteUserFolder(username);

                  setdeleteError("Trained data deleted successfully!");
                } catch (error) {
                  console.error("Delete failed:", error);
                  setdeleteError("Failed to delete trained data!");
                }
              }}
            >
              Delete Trained Data
            </Button>
            <br />
            <br />
            {deleteError}
          </div>
          <div className="result-chatbot">
            {/* <h4>Chatbot</h4> */}
            <h3>
              <strong>Chat Window</strong>
            </h3>
            <hr style={{ background: "white" }}></hr>
            <div style={{ position: "relative", height: "500px" }}>
              <MainContainer>
                <ChatContainer style={{ padding: "0.5rem" }}>
                  <MessageList
                    typingIndicator={
                      answerload && (
                        <TypingIndicator content="chatbot is typing" />
                      )
                    }
                    autoScrollToBottomOnMount={true}
                  >
                    {messages.map((message) => (
                      // Render message list item
                      <Message
                        model={{
                          message: message.text,
                          direction: message.direction,
                        }}
                      />
                    ))}
                  </MessageList>
                  <MessageInput
                    attachButton={false}
                    placeholder="Type message here"
                    onSend={handleSendMessage}
                  />
                  {/* <InputToolbox>
                    <AttachmentButton />
                    <SendButton />
                  </InputToolbox> */}
                </ChatContainer>
              </MainContainer>
            </div>
            {/* {answerload && "Generating..."} */}
            {/* <div className="output-result">{output["messsage"]}</div>
            <div className="output-result">
              {output["errorMessage"] && "Something went wrong."}
            </div> */}
            {/* {console.log(messages)} */}
            {/* <Button variant="contained" onClick={handleQuestion}>
            Ask
          </Button> */}
            <div style={{ margin: "1rem auto", textAlign: "right" }}>
              <Button
                onClick={exportMessages}
                variant="contained"
                color="primary"
              >
                Export chat
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
    </div>
  );
}
